import React from 'react';

import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

import VerticalBarChart from 'src/features/statistic/components/chart/VerticalBarChart';
import { statisticMessages } from 'src/features/statistic/utils/messages';
import { useTitleStore } from 'src/stores/useTitleStore';

export default function GatewayStatistics() {
    const { formatMessage } = useIntl();
    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(statisticMessages.gatewayStatistics));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            <VerticalBarChart date={dayjs()} />
            <VerticalBarChart date={dayjs().subtract(1, 'day')} />
            <VerticalBarChart date={dayjs().subtract(2, 'day')} />
        </div>
    );
}
